import {defineStore} from 'pinia';
import Api from '@services/api';
import {removeEmptyParams} from '@utils';

export const useZoneStore = defineStore('zone', {
  state: () => ({zones: undefined}),
  actions: {
    async all() {
      if (this.isFilled()) return this.zones;
      let zones = await Api(true, false)
        .get('/zones', {params: removeEmptyParams({})})
        .then((res) => {
          return res.data;
        });
      this.$patch({
        zones: zones,
      });
      return this.zones;
    },
    clear() {
      this.$patch({
        zones: undefined,
      });
    },
    isFilled() {
      return this.zones !== undefined;
    },
  },
});
